import CardModalDetails from './CardModalDetails';
import CardModalDeliveryAddress from './CardModalDeliveryAddress';
import CardModalUsageOptions from './CardModalUsageOptions';
import CardModalProductsAndServices from './CardModalProductsAndServices';

/**
 * Don't use this component, it's a placeholder for the CardModal sub components.
 */
export default function CardModal() {
  return <></>;
}

CardModal.Details = CardModalDetails;
CardModal.DeliveryAddress = CardModalDeliveryAddress;
CardModal.UsageOptions = CardModalUsageOptions;
CardModal.ProductsAndServices = CardModalProductsAndServices;
